import axiosInstance from "../../../helpers/api";

export const getWhatsappTemplates = () => {
  return axiosInstance.get("/admin/whatsapp-templates");
};

export const getWhatsappTemplate = (name) => {
  return axiosInstance.get(
    `/admin/whatsapp-templates/${encodeURIComponent(name)}`
  );
};

export const updateWhatsappTemplate = (name, body) => {
  return axiosInstance.put(
    `/admin/whatsapp-templates/${encodeURIComponent(name)}`,
    body
  );
};
